import React, { useState, useEffect } from 'react';
import '../App.css';
import { Link, useNavigate } from 'react-router-dom';
import { Form, FormGroup, Button, Label, Input } from 'reactstrap';
import MyStorage from './util/storage'
import showToast from './util/toast'
import { Oval as Loader } from 'react-loader-spinner'
import { ToastContainer } from 'react-toastify';
import Api from '../cmp/admin/cmp/api/api'

const MindArticles = () => {
  const navigate = useNavigate()
  const [models, setModels] = useState([])
  const [loader, setLoader] = useState(false)

  useEffect(() => {
    loadData()
  }, [])

  const loadData = () => {
    setLoader(true)
    Api.getMindArticles(
      (response) => {
        setLoader(false)
        setModels(response)
      },
      (error) => {
        setLoader(false)
      });
  };

  return (
    <main style={{ width: "min(1100px, 94%)", margin: "28px auto" }}>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "baseline" }}>
        <h1 style={{ margin: 0 }}>Mind Articles</h1>
        <div style={{ color: "#6b7280" }}>
          <Link to="/">Home</Link> / <strong>Mind Articles</strong>
        </div>
      </div>

      {loader ? (
        <div style={{ padding: 40 }}>Loading…</div>
      ) : models.length === 0 ? (
        <div style={{ padding: 40 }}>No articles found.</div>
      ) : (
        <div style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', justifyContent: 'center' }}>

          {models.map((item, index) => {
            return (
              <div style={{ width: '100%', backgroundColor: 'white', marginTop: 10, padding: 0, marginRight: 10, display: 'flex', justifyContent: 'center', flexDirection: 'column' }}>

                <div style={{ display: 'flex', borderRadius: 10, backgroundColor: '#f2f2f2', padding: 10 }}>

                  <div style={{}}>
                    {item.images.length > 0 ?
                      <img
                        src={item.images.length > 0 ? item.images[0] : null}
                        style={{ backgroundColor: '#fff', width: 200, height: 150, border: '0px solid lightgray', objectFit: 'cover', marginRight: 15, alignSelf: 'center' }} />
                      :
                      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', backgroundColor: '#fff', width: 120, height: 120, border: '0px solid lightgray', objectFit: 'cover', marginRight: 15, alignSelf: 'center' }}>
                        <div style={{ color: 'gray' }}>No Image</div>
                      </div>

                    }
                  </div>

                  <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', justifyContent: 'center' }}>
                    <div style={{ display: 'flex', alignSelf: 'flex-start' }}>
                      {/* <div style={{ fontSize: 16, display: 'flex', color: 'gray' }}>Business Name:</div> */}
                      <div style={{ fontSize: 18, display: 'flex', marginLeft: 0 }}>{item.title}</div>
                    </div>
                    <div
                      style={{cursor:'pointer', display: 'flex', marginTop: 10, color: 'white', borderRadius: 5, alignItems: 'center', justifyContent: 'center', fontSize: 18, marginRight: 10, fontWeight: 'bold', width: '100%', backgroundColor: '#02af90', borderWidth: 0, height: 40, width: 200 }}
                      onClick={() => {
                        // navigate(`/education-article/${item.id}`)
                        navigate('/mind-article', { state: { article: item } });
                      }}>
                      Read Article
                    </div>

                    {/* <div style={{ display: 'flex' }}>
                        <div style={{ fontSize: 16, display: 'flex' }}>{item.detail}</div>
                      </div> */}

                  </div>
                </div>
              </div>
            )
          })}
        </div>
      )}
    </main>
  );
}

export default MindArticles;